import { Module } from "vuex";
import { RootState } from "../types";
import { EventLinksState } from "./types";
import { getDefaultState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

export const state: EventLinksState = getDefaultState();
const namespaced: boolean = true;

export const eventLinks: Module<EventLinksState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
